<script>
	import { nanoid } from "nanoid";

	export let id = nanoid(6);
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let readonly = false;
	export let placeholder = null;
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}

	</label>
{/if}

<div>
    <slot>
		{!!value ? value : ""}
	</slot>
</div>

<style>
	div {
		appearance: none;
		background-color: transparent;
		border: solid 1px var(--color-border);
		border-radius: 4px;
		padding: .5rem;
		transition: var(--transition-fast);
		min-height: 40px;
		font-size: 18px;
		line-height: 26px;
		color: var(--color-body);
		overflow: hidden;
	}
</style>

